function getCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

const AtelierSessionManager = {
  STORAGE_KEY: 'is_store_session',
  UTM_VALUE: 'store',

  hasUtmStoreParam: function() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('utm_source') === this.UTM_VALUE;
  },

  hasOnBehalfCookie: function() {
    return !!getCookie('mf_lac_logged');
  },

  isStoreSession: function() {
    return sessionStorage.getItem(this.STORAGE_KEY) === 'true';
  },

  setStoreSession: function() {
    sessionStorage.setItem(this.STORAGE_KEY, 'true');
  },

  addUtmToUrl: function() {
    const url = new URL(window.location.href);
    if (url.searchParams.get('utm_source') !== this.UTM_VALUE) {
      url.searchParams.set('utm_source', this.UTM_VALUE);
      window.history.replaceState({}, '', url.toString());
    }
  },

  init: function() {
    if (this.hasOnBehalfCookie()) {
      this.addUtmToUrl();
      this.setStoreSession();
    }

    if (this.hasUtmStoreParam() && !this.isStoreSession()) {
      this.setStoreSession();
    }

    return this.isStoreSession();
  }
};

AtelierSessionManager.init();

const ON_BEHALF_CLEANUP_KEY = 'on_behalf_cleanup_done';

// A cart keeps its attributes for as long as it lives (even empty, even for months on a
// logged in customer), so after the on-behalf logout the stale flag must be removed here.
function clearStaleOnBehalfAttribute() {
  if (sessionStorage.getItem(ON_BEHALF_CLEANUP_KEY) === 'true') return;

  fetch(window.Shopify.routes.root + 'cart.js')
    .then((response) => response.json())
    .then((cart) => {
      if (cart.attributes && cart.attributes['login-as']) {
        const formData = new FormData();
        formData.append('attributes[login-as]', '');

        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData,
        });
      }
    })
    .then(() => sessionStorage.setItem(ON_BEHALF_CLEANUP_KEY, 'true'))
    .catch((error) => {});
}

function addCartAttribute() {
  const cookieValue = getCookie('mf_lac_logged');
  const isStoreSession = AtelierSessionManager.isStoreSession();

  if (cookieValue) {
    sessionStorage.removeItem(ON_BEHALF_CLEANUP_KEY);
  } else {
    clearStaleOnBehalfAttribute();
  }

  if (!cookieValue && !isStoreSession) return;

  const formData = new FormData();

  if (cookieValue) {
    formData.append('attributes[login-as]', 'on-behalf');
  }

  if (isStoreSession) {
    formData.append('attributes[order-source]', 'store');
  }

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => {});
}

function setShopifySession() {
  const cookieShopifySessionValue = getCookie('_shopify_s');
  if (cookieShopifySessionValue) {
    localStorage.setItem('shopify_session', cookieShopifySessionValue);
  }
}

function hideConsumerUserProductIdElements() {
  document.querySelectorAll('dd').forEach(dd => {
    if (dd.textContent.includes('consumerUserProductId')) {
      dd.style.display = 'none';
    }
  });
  document.querySelectorAll('.account-dashboard__table-info').forEach(info => {
    if (info.textContent.includes('consumerUserProductId')) {
      info.style.display = 'none';
    }
  });
}

addCartAttribute();
setShopifySession();
hideConsumerUserProductIdElements();
